import { render, staticRenderFns } from "./StockMaterialList.vue?vue&type=template&id=1f2fbe04&scoped=true"
import script from "./StockMaterialList.vue?vue&type=script&lang=js"
export * from "./StockMaterialList.vue?vue&type=script&lang=js"
import style0 from "./StockMaterialList.vue?vue&type=style&index=0&id=1f2fbe04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2fbe04",
  null
  
)

export default component.exports